export enum DrawerMode {
    CREATE,
    EDIT,
    VIEW,
    NONE,
}
